import React, { Component } from 'react'
import SweetAlert from "react-bootstrap-sweetalert";

export default class OnlinePaymentAlert extends Component {

    constructor(props) {
        super(props);
        this.state = {
            alert: null
        }
    }

    showOnlinePaymentInProgressAlert() {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: "block" }}
                    title={<div className="text-info">Un pago se está procesando. Porfavor vuelve a intentarlo más tarde.</div>}
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="info"
                />
            )

        });
    }

    hideAlert() {
        this.setState({
            alert: null
        });
    }

    render() {
        return (
            <div>
                {this.state.alert}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/OnlinePaymentAlert/OnlinePaymentAlert.jsx